export default __webpack_public_path__ + "static/media/welcome.11b37b10.png";